/**
 * Sticky add-to-cart bar — shows on mobile when the main buy button scrolls out of view.
 */
class FabrixStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    // Find the main buy buttons section
    const sectionId = this.dataset.sectionId;
    const buyButtons = document.querySelector(
      `#ProductInfo-${sectionId} .product-form__submit, #ProductInfo-${sectionId} [name="add"]`
    );

    if (!buyButtons) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('fabrix-sticky-atc--visible');
            this.setAttribute('aria-hidden', 'true');
          } else {
            this.classList.add('fabrix-sticky-atc--visible');
            this.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0 }
    );

    this.observer.observe(buyButtons);

    // Forward click to the real form submit button
    const stickyButton = this.querySelector('.fabrix-sticky-atc__button');
    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        buyButtons.click();
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('fabrix-sticky-atc', FabrixStickyAtc);
